<template lang="">
  <div>
    <LaudoTransvaginalHisterectomia></LaudoTransvaginalHisterectomia>
  </div>
</template>
<script>
import LaudoTransvaginalHisterectomia from "../components/laudos/formularios/exames/transvaginalHisterectomia/LaudoTransvaginalHisterectomia.vue";
export default {
  components: {
    LaudoTransvaginalHisterectomia,
  },
};
</script>
<style lang=""></style>
